import { render, staticRenderFns } from "./BookingDetailsDocument.vue?vue&type=template&id=263b0981"
import script from "./BookingDetailsDocument.vue?vue&type=script&lang=js"
export * from "./BookingDetailsDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports